(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var closeButton = event.target.closest('.custom-announcement-bar__close');
  if (!closeButton) return;

  var bar = closeButton.closest('.custom-announcement-bar');
  if (bar) {
    bar.style.display = 'none';
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('.custom-announcement-bar__items');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var items = container.querySelectorAll('.announcement-item');
    if (items.length <= 1) return;

    var mq = window.matchMedia('(max-width: 749px)');
    var currentIndex = 0;

    function showAllDesktop() {
      items.forEach(function (item) {
        item.style.display = 'inline-flex';
        item.classList.remove('is-active');
      });
    }

    function showOneMobile(index) {
      items.forEach(function (item, i) {
        if (i === index) {
          item.style.display = 'inline-flex';

          // Animation jedes Mal neu starten
          item.classList.remove('is-active');
          void item.offsetWidth; // force reflow
          item.classList.add('is-active');
        } else {
          item.style.display = 'none';
          item.classList.remove('is-active');
        }
      });
    }

    function setupForScreen() {
      if (mq.matches) {
        showOneMobile(currentIndex);
      } else {
        showAllDesktop();
      }
    }

    setupForScreen();

    if (mq.addEventListener) {
      mq.addEventListener('change', setupForScreen);
    } else if (mq.addListener) {
      mq.addListener(setupForScreen);
    }

    setInterval(function () {
      if (!mq.matches) return;
      currentIndex = (currentIndex + 1) % items.length;
      showOneMobile(currentIndex);
    }, 3000);
  });
});

  } catch(e) { console.error(e); }
})();
})();
